module.exports = __webpack_public_path__ + "static/img/9.3602c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.png
// module id = E2RZ
// module chunks = 13